import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function CustomModel(props: any ) {

    return (
      <div>
      <Dialog open={props.isModelOpen} onClose={props.toggleCustomModel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{props.dialogTitle}</DialogTitle>
        <DialogContent>
          {
            props?.dialogContentText && <DialogContentText>
               { props?.dialogContentText }
          </DialogContentText>
}
      {props.dialogBody}
          
        </DialogContent>
        <DialogActions>
          {
            props.dialogActionButton
          }
        </DialogActions>
      </Dialog>
    </div>
    )
}

export default CustomModel
